export function parseTokenizedQuery(search: string): URLSearchParams {
  const normalized = (search ?? "")
    .replace(/&amp;/gi, "&")
    .replace(/&#x0*26;/gi, "&")
    .replace(/&#0*38;/g, "&");
  return new URLSearchParams(normalized);
}
